import { nodeArray } from 'meteora';
import inView from 'in-view';
document.addEventListener('DOMContentLoaded', function () {
  nodeArray(document.querySelectorAll('.js-stagger-svg svg')).forEach(function (svg) {
    nodeArray(svg.children).forEach(function (path) {
      path.style.opacity = 0;
    });
  });
  inView('.js-stagger-svg svg').on('enter', function (svg) {
    setTimeout(function () {
      nodeArray(svg.children).forEach(function (path, index) {
        setTimeout(function () {
          path.style.opacity = 1;
        }, 100 * index);
      });
    }, 1500);
  }).on('exit', function (svg) {
    nodeArray(svg.children).forEach(function (path) {
      path.style.opacity = 0;
    });
  });
});